import { render, staticRenderFns } from "./TkFavoriteModal.vue?vue&type=template&id=18d05055&"
import script from "./TkFavoriteModal.vue?vue&type=script&lang=js&"
export * from "./TkFavoriteModal.vue?vue&type=script&lang=js&"
import style0 from "./TkFavoriteModal.vue?vue&type=style&index=0&id=18d05055&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports